export default "/apps/maps/img/leaflet.routing.icons.png";